'use strict';

import Bubble from './bubbleChat';
import Multilanguage from './../homepage/multilanguage';
import FormHelpers from './../util/form';
import NewsletterPopupNew from './../homepage/newsletterPopupNew';
import NewsletterPopup from './../homepage/newsletterPopup';
import ExternalScript from './externalscripts';
import { newModalFromString } from '../components/modal';
// import { initStoreLocatorModal } from '../storeLocatorModal';
import Newsletter from './../newsletter';
import {
    cookieExists,
    createCookie,
    appendToUrl
} from './../util/common';
// import { woosmapInitFooter } from '../components/woosmap.footer';
import { woosmapInitFooter } from 'woosmap';

var isNewsletterContactsInit = false;
const newsletterContactsInit = () => {
    $('#newsletterFooterFormContacts').on('submit', function (e) {
        e.preventDefault();
    });
    $('#submitNewsletterContacts').on('click', function (e) {
        const newsletterEmail = $('#newsletter-Email-contacts');
        if (newsletterEmail.val() === '' || newsletterEmail.parsley().isValid()) {
            newsletterEmail.blur();
            e.preventDefault();
            $('#newsletterFooterForm').data('which-form', 'newsletter-contacts');
            NewsletterPopup.showPopup();
            $('body').trigger('footer:NewsletterStep1');
        }
    });
};

const toggleCountrySelector = () => {
    $('#countryChooser').slideToggle('5000');
    $('#languageChooser').hide();
    $('body').css('overflow', 'hidden');
    $('.country-chooser-overlay-blur').toggle();
    $('.language-chooser-overlay-blur').hide();
    $('.footer-full__last, .footer-full__bottom, .footer-full__middle--full').addClass('open-country-language');

    $('.countryFooterClose').on('click', function (e) {
        $('.country-chooser-overlay-blur').hide();
        $('body').css('overflow', 'auto');
        $('#countryChooser').slideUp();
        $('.js-country').removeClass('arrow-toggle');
        $('.footer-full__last, .footer-full__bottom, .footer-full__middle--full').removeClass('open-country-language');
    });
    $('.js-country').toggleClass('arrow-toggle');

    if (!isNewsletterContactsInit) {
        newsletterContactsInit();
        isNewsletterContactsInit = true;
    }
};

const toggleLanguageSelector = () => {
    $('#languageChooser').slideToggle('5000');
    $('#countryChooser').hide();
    $('body').css('overflow', 'hidden');
    $('.country-chooser-overlay-blur').hide();
    $('.language-chooser-overlay-blur').toggle();
    $('.footer-full__last, .footer-full__bottom, .footer-full__middle--full').addClass('open-country-language');

    if ($('.js-language').length && $('#language-inner-content').length) {
        const rectangle = $('.js-language')[0].getBoundingClientRect();
        const heightAbove = $('#languageChooser').outerHeight() - $('#language-inner-content').outerHeight();
        const maxHeight = rectangle.bottom - heightAbove - rectangle.height;
        $('#language-inner-content')[0].style.height = maxHeight + 'px';
    }
    $('.languageFooterClose').on('click', function (e) {
        $('.language-chooser-overlay-blur').hide();
        $('body').css('overflow', 'auto');
        $('#languageChooser').slideUp();
        $('.js-language').removeClass('arrow-toggle');
        $('.footer-full__last, .footer-full__bottom, .footer-full__middle--full').removeClass('open-country-language');
    });
    $('.js-language').toggleClass('arrow-toggle');
};

class Footer {
    init () {
        this.registerEvents();
        if ($('.overlay-bubble-chat--tezenis').length) {
            Bubble.init();
        }
        this.multilanguageSubmit();
        this.cookieBannerHandler();
        this.cookieBannerCloseHandler();
        this.orderStatusForm();
        this.storeLocator();
        ExternalScript.init();
    }

    registerEvents () {
        if (cookieExists('cookie_closed') || (cookieExists('OptanonAlertBoxClosed') && cookieExists('OptanonConsent'))) {
            var condition = false;
            Multilanguage.init(condition);
            NewsletterPopupNew.init();
        }

        $('#submitNewsletter').on('click', function (e) {
            const newsletterEmail = $('#newsletter-Email');
            if (newsletterEmail.val() === '' || newsletterEmail.parsley().isValid()) {
                newsletterEmail.blur();
                e.preventDefault();
                $('#newsletterFooterForm').data('which-form', 'newsletter');
                NewsletterPopup.showPopup();
                $('body').trigger('footer:NewsletterStep1');
            }
        });

        $('.language-chooser-overlay-blur').on('click', function (e) {
            if (!$(e.target).hasClass('js-language') && $('#languageChooser').css('display') == 'block') {
                $('#languageChooser').slideUp();
                $('.language-chooser-overlay-blur').hide();
                $('body').css('overflow', 'auto');
                $('.js-language').removeClass('arrow-toggle');
                $('.footer-full__last, .footer-full__bottom, .footer-full__middle--full').removeClass('open-country-language');
            }
        });

        $('.country-chooser-overlay-blur').click(function (e) {
            if (!$(e.target).hasClass('js-country') && $('#countryChooser').css('display') == 'block') {
                $('#countryChooser').slideUp();
                $('.country-chooser-overlay-blur').hide();
                $('body').css('overflow', 'auto');
                $('.js-country').removeClass('arrow-toggle');
                $('.footer-full__last, .footer-full__bottom, .footer-full__middle--full').removeClass('open-country-language');
            }
        });

        $('.js-store-locator-form-menu').click(function (e) {
            e.preventDefault();
            $('.find-in-store-btn-footer').trigger('click');
        });

        $(window).on('resize', function (e) {
            checkScreenSize();
        });

        checkScreenSize();

        function checkScreenSize () {
            var newWindowWidth = $(window).width();
            if (newWindowWidth < 1080) {
                $('.js-pre-footer-button').removeClass('button-primary-black').addClass('button-secondary-black');
            } else {
                $('.js-pre-footer-button').addClass('button-primary-black').removeClass('button-secondary-black');
            }
        }

        $(document)
            .on('click', '.js-country', function (e) {
                e.preventDefault();
                let url = $(e.currentTarget).data('url');
                if (url && $('#countryChooser').children().length === 0) {
                    $.spinner().start();
                    $.ajax(url).then(function (rsp) {
                        $.spinner().stop();
                        if (rsp) {
                            $('#countryChooser').html(rsp);
                            toggleCountrySelector();
                        }
                    });
                } else {
                    toggleCountrySelector();
                }
                $('.js-language').removeClass('arrow-toggle');
            })
            .on('click', '.js-language', function (e) {
                e.preventDefault();
                let url = $(e.currentTarget).data('url');
                if (url && $('#languageChooser').children().length === 0) {
                    $.spinner().start();
                    $.ajax(url).then(function (rsp) {
                        $.spinner().stop();
                        if (rsp) {
                            $('#languageChooser').html(rsp);
                            toggleLanguageSelector();
                        }
                    });
                } else {
                    toggleLanguageSelector();
                }
                $('.js-country').removeClass('arrow-toggle');
            })
            .on('click', '.arrow-toggle', function (e) {
                $('body').css('overflow', 'auto');
                $('.footer-full__last, .footer-full__bottom, .footer-full__middle--full').removeClass('open-country-language');
            })
            .on('click', '.js-country-line', function (evt) {
                const $target = $(evt.currentTarget);
                var $clickedCheckbox = $target.find('input[type="checkbox"]');
                $('.js-country-line input[type="checkbox"]').not($clickedCheckbox).prop('checked', false);
                if ($target.hasClass('action-change')) {
                    return;
                }
                const url = $target.data('href');
                const locale = $target.data('locale');
                const currency = $target.data('currency');
                const action = $('.page').data('action') || 'Home-Show';

                $.ajax({url: url,
                    data: {
                        code: locale,
                        currency: currency,
                        queryString: $('.page').data('querystring'),
                        action: action
                    }
                }).then(function (rsp) {
                    if (rsp.redirectUrl) {
                        document.location.href = rsp.redirectUrl;
                    }
                });
            })
            .on('change', 'input:radio[name=countries]', function () {
                $('#setInputLocaleCountry').attr('data-locale', this.value);
            });
    }

    multilanguageSubmit () {
        $('body').on('submit', '.multilanguage', function (e) {
            var $form = $(this);
            e.preventDefault();
            var url = $form.attr('action');
            $.spinner().start();
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: $form.serialize(),
                success: function (data) {
                    $form.spinner().stop();
                    if (!data.success) {
                        FormHelpers.init($form, data);
                    } else {
                        window.location.href = data.redirectUrl;
                    }
                },
                error: function (data) {
                    if (data.responseJSON.redirectUrl) {
                        window.location.href = data.responseJSON.redirectUrl;
                    } else {
                        $form.spinner().stop();
                    }
                }
            });
            return false;
        });
    }

    cookieBannerHandler () {
        $('body').on('click', '#onetrust-accept-btn-handler, .onetrust-close-btn-handler, #accept-recommended-btn-handler', function (e) {
            if (!cookieExists('cookie_closed')) {
                createCookie('cookie_closed', 'true');
                createCookie('cookie_profiling_consent', 'true');
                var condition = false;
                Multilanguage.init(condition);
                NewsletterPopupNew.init();
            }
        });
    }

    cookieBannerCloseHandler () {
        $('body').on('click', '#onetrust-close-btn-container', function (e) {
            createCookie('cookie_profiling_consent', 'false');
        });
    }

    orderStatusForm () {
        function openOrderStatusForm () {
            const htmlContent = $('.js-modal-web-order-status-form-request').html();
            var tabContent = $('.js-content-web-order-status-form-request').html();

            const modal = newModalFromString(htmlContent, false, ['wrapperModal', 'tingle-modal-form-request', 'order-status-new-form']);
            modal.open();
            modal.setContent(tabContent);
            $(modal.modalBox).addClass('modal-tabs-style');
            $(modal.modalBox)
                .find('.close-button')
                .on('click', function (e) {
                    modal.close();
                });

            $('.js-inside-close-modal').on('click', function (e) {
                e.preventDefault();
                modal.close();
            });

            $('[data-dismiss="modal"]').on('click', function (e) {
                e.preventDefault();
                modal.close();
            });
        }

        var url = new URL(window.location.href);
        var showOrderStatus = url.searchParams.get('showOrderStatus');

        if (showOrderStatus) {
            openOrderStatusForm();
        }

        $('body').on('click', 'a[data-name="follow-your-order"]', function (e) {
            e.preventDefault();
            openOrderStatusForm();
        });

        $('body').on('click', '#form-order-status button', function (e) {
            let errors = [];
            $('#form-order-status :input:not(:button)').each(function (index, value) {
                let validator = $(this).parsley({
                    errorClass: 'is-invalid-input'
                });
                validator.validate();
                if (!validator.isValid()) {
                    errors.push(validator);
                }
            });
            if (errors.length > 0) {
                e.preventDefault();
            }
        });
    }

    storeLocator () {
        /*
        $('body').on('click', '[data-name="find-your-store"], [data-name="finding-store"]', function (e) {
            e.preventDefault();
            $('.find-in-store-btn-footer').trigger('click');
        });
        */

        $('body').on('woosmap:chooseOptionFooter', function (_e, selection) {
            if (selection.geometry && selection.geometry.location.lat && selection.geometry.location.lng) {
                const $form = $('.find-in-store-btn-footer');
                var coords = {
                    lat: selection.geometry.location.lat,
                    long: selection.geometry.location.lng
                };
                var updatedAction = appendToUrl($form.data('url'), coords);
                $form.data('url', updatedAction);
                $('.woosmap-search').val(true);
                $('.find-in-store-btn-footer').trigger('click');
            }
        });

        $('#storelocatorFooterForm').on('submit', function (e) {
            e.preventDefault();
        });

        $('.find-in-store-btn-footer').on('click', function (e) {
            // Fix: Ensure search button triggers the top Woosmap autocomplete suggestion,
            // aligning click behavior with 'Enter' key logic for City/Zip filtering.
            var $btn = $(this);
            var url = $btn.data('url');
            
            if (url.indexOf('lat=') === -1) {
                var $firstSuggestion = $('#footer-woosmap-suggestion .localities-item').first();

                if ($firstSuggestion.length > 0) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    $firstSuggestion.trigger('click');

                    return false;
                } 
            }
            $.spinner().start();
            var url = $(this).data('url');
            $.ajax(url).then(function (data) {
                const modal = newModalFromString(data, false, ['store-locator-modal']);
                modal.open();
                __webpack_public_path__ = window.ll_script.base;
                import(/* webpackChunkName: "storeLocatorModal" */ '../storeLocatorModal').then((storelocator) => {
                    let fs = storelocator.default;
                    fs.initStoreLocatorModal();
                });

                $('.storeLocatorNearbyList').on('click', function () {
                    $('.results-card').show();
                    $('.map-canvas-modal').hide();
                    $('.storeLocatorNearbyMap').addClass('change-opacity');
                    $('.storeLocatorNearbyList').removeClass('change-opacity');
                });

                $('.storeLocatorNearbyMap').on('click', function () {
                    $('.map-canvas-modal').show();
                    $('.results-card').hide();
                    $('.storeLocatorNearbyList').addClass('change-opacity');
                    $('.storeLocatorNearbyMap').removeClass('change-opacity');
                });

                $(modal.modalBox)
                    .find('.close-button')
                    .on('click', function (e) {
                        modal.close();
                        $('.find-in-store-btn-footer').data('url', $('#searchURL').data('url'));
                        $('#modal-woosmap-suggestion').remove();
                    });

                $('.js-inside-close-modal').on('click', function (e) {
                    e.preventDefault();
                    modal.close();
                    $('.find-in-store-btn-footer').data('url', $('#searchURL').data('url'));
                    $('#modal-woosmap-suggestion').remove();
                });

                $('[data-dismiss="modal"]').on('click', function (e) {
                    e.preventDefault();
                    modal.close();
                    $('.find-in-store-btn-footer').data('url', $('#searchURL').data('url'));
                    $('#modal-woosmap-suggestion').remove();
                });

                $('.detect-location').on('click', function (e) {
                    $('#store-postal-code').val('');
                });

                $('#store-postal-code').val($('#footer-find-store').val());
                $('body').trigger('storeLocator:searchWithZipCode', { city: $('#footer-find-store').val(), action: 'search_for_a_shop' });
                $.spinner().stop();
            });
        });

        $('#footer-find-store').on('mouseenter', function (e) {
            woosmapInitFooter($('.storeLocatorWorldFooter').length <= 0);
            $('#footer-find-store').off();
            $('.localities-container:first').prop('id', 'footer-woosmap-suggestion');
        });
        $('body').on('focusin', '.localities-input-wrapper', (e) => {
            $(e.currentTarget).closest('.form-item').find('.form-control-label').css('opacity', '1');
        });
        $('body').on('focusout', '.localities-input-wrapper', (e) => {
            $(e.currentTarget).closest('.form-item').find('.form-control-label').css('opacity', '0');
        });
    }
}

const footer = new Footer();
export default footer;
